import { render, staticRenderFns } from "./DepartmentType.vue?vue&type=template&id=21885dfc"
import script from "./DepartmentType.vue?vue&type=script&lang=js"
export * from "./DepartmentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports